(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-product-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const typeDefinitions = [
      ['Heimtrikot', /\b(?:heim|home)(?:\s|-)?trikot\b/i],
      ['Auswärtstrikot', /\b(?:ausw(?:ä|ae)rts|away)(?:\s|-)?trikot\b/i],
      ['Drittes Trikot', /\b(?:drittes|3\.?|third)(?:\s|-)?trikot\b/i],
      ['Viertes Trikot', /\b(?:viertes|4\.?|fourth)(?:\s|-)?trikot\b/i],
      ['Torwarttrikot', /\btorwart(?:\s|-)?trikot\b/i],
      ['Trainingstrikot', /\btrainings?(?:\s|-)?trikot\b/i],
      ['Sondertrikot', /\bsonder(?:\s|-)?trikot\b/i],
      ['Trikot', /\btrikot\b/i]
    ];

    const brandDefinitions = [
      ['adidas', /\badidas\b/i],
      ['Nike', /\bnike\b/i],
      ['Puma', /\bpuma\b/i],
      ['Umbro', /\bumbro\b/i],
      ['Reebok', /\breebok\b/i],
      ['Hummel', /\bhummel\b/i],
      ['Kappa', /\bkappa\b/i],
      ['Uhlsport', /\buhlsport\b/i],
      ['Joma', /\bjoma\b/i],
      ['Erima', /\berima\b/i],
      ['Lotto', /\blotto\b/i],
      ['Macron', /\bmacron\b/i],
      ['New Balance', /\bnew\s+balance\b/i]
    ];

    const clubAliases = {
      hsv: 'Hamburger SV',
      'hamburger sv': 'Hamburger SV',
      dfb: 'Deutschland'
    };

    const parseTitle = (title) => {
      const seasonMatch = title.match(/\b(?:\d{2}[-/]\d{2}|(?:19|20)\d{2}(?:[-/](?:\d{2}|\d{4}))?)\b/);
      const sizeMatch = title.match(/\bGr\.?\s*([A-Za-z0-9./-]+)\b/i);
      const typeDefinition = typeDefinitions.find((definition) => definition[1].test(title));
      const typeMatch = typeDefinition ? title.match(typeDefinition[1]) : null;
      const brandDefinition = brandDefinitions.find((definition) => definition[1].test(title));
      const brand = brandDefinition ? brandDefinition[0] : '';

      const clubBoundaries = [seasonMatch, typeMatch, sizeMatch]
        .filter(Boolean)
        .map((match) => match.index);
      const clubEnd = clubBoundaries.length ? Math.min(...clubBoundaries) : title.length;

      let club = title.slice(0, clubEnd).trim();
      brandDefinitions.forEach((definition) => {
        club = club.replace(definition[1], '').trim();
      });
      club = club.replace(/^[-–—·\s]+|[-–—·\s]+$/g, '');
      club = clubAliases[club.toLowerCase()] || club;

      let print = '';
      if (typeMatch) {
        const printStart = typeMatch.index + typeMatch[0].length;
        const printEnd = sizeMatch ? sizeMatch.index : title.length;
        print = title.slice(printStart, printEnd);
        if (seasonMatch) print = print.replace(seasonMatch[0], '');
        brandDefinitions.forEach((definition) => { print = print.replace(definition[1], ''); });
        print = print
          .replace(/\b\d+\s*(?:Jahre?|Years?)\b/gi, '')
          .replace(/\bSondermodell\b/gi, '')
          .replace(/^[-–—·\s]+|[-–—·\s]+$/g, '')
          .replace(/\s{2,}/g, ' ')
          .trim();
      }

      const type = typeDefinition ? typeDefinition[0] : '';
      const mainTitle = [type, print].filter(Boolean).join(' · ') || title;

      return {
        brand,
        club,
        season: seasonMatch ? seasonMatch[0].replace('/', '–').replace('-', '–') : '',
        type,
        size: sizeMatch ? sizeMatch[1] : '',
        print,
        mainTitle
      };
    };

    const initProduct = (root) => {
      const title = root.dataset.productTitle || '';
      const parsed = parseTitle(title);
      const condition = (root.dataset.productCondition || '').replace(/^Zustand\s*:\s*/i, '').trim();
      const titleNode = root.querySelector('[data-lm-title]');
      const eyebrowNode = root.querySelector('[data-lm-eyebrow]');
      const sizeNode = root.querySelector('[data-lm-size]');

      if (titleNode) titleNode.textContent = parsed.mainTitle;
      if (eyebrowNode) {
        eyebrowNode.textContent = [parsed.club, parsed.season].filter(Boolean).join(' · ');
        eyebrowNode.hidden = !eyebrowNode.textContent;
      }
      if (sizeNode) {
        sizeNode.textContent = parsed.size ? `Größe ${parsed.size}` : '';
        sizeNode.hidden = !parsed.size;
      }

      const detailValues = { ...parsed, condition };
      Object.entries(detailValues).forEach(([key, value]) => {
        const row = root.querySelector(`[data-lm-row="${key}"]`);
        const node = root.querySelector(`[data-lm-value="${key}"]`);
        if (!row || !node || key === 'mainTitle') return;
        node.textContent = value;
        row.hidden = !value;
      });

      const panels = Array.from(root.querySelectorAll('[data-lm-media]'));
      const thumbs = Array.from(root.querySelectorAll('[data-lm-thumb]'));
      const dots = Array.from(root.querySelectorAll('[data-lm-dot]'));
      const counts = Array.from(root.querySelectorAll('[data-lm-count]'));
      let activeIndex = 0;

      const selectMedia = (index) => {
        if (!panels.length) return;
        activeIndex = (index + panels.length) % panels.length;
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === activeIndex;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === activeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
        counts.forEach((count) => {
          count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(panels.length).padStart(2, '0')}`;
        });
      };

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => selectMedia(Number(thumb.dataset.lmThumb))));
      root.querySelectorAll('[data-lm-previous]').forEach((button) => button.addEventListener('click', () => selectMedia(activeIndex - 1)));
      root.querySelectorAll('[data-lm-next]').forEach((button) => button.addEventListener('click', () => selectMedia(activeIndex + 1)));

      const stage = root.querySelector('[data-lm-stage]');
      let touchStartX = 0;
      let touchStartY = 0;
      if (stage) {
        stage.addEventListener('touchstart', (event) => {
          touchStartX = event.changedTouches[0].clientX;
          touchStartY = event.changedTouches[0].clientY;
        }, { passive: true });
        stage.addEventListener('touchend', (event) => {
          const distanceX = event.changedTouches[0].clientX - touchStartX;
          const distanceY = event.changedTouches[0].clientY - touchStartY;
          const isHorizontalSwipe = Math.abs(distanceX) > 42 && Math.abs(distanceX) > Math.abs(distanceY) * 1.2;
          if (isHorizontalSwipe) selectMedia(activeIndex + (distanceX < 0 ? 1 : -1));
        }, { passive: true });
      }

      const variantSelect = root.querySelector('[data-lm-variant-select]');
      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          const option = variantSelect.options[variantSelect.selectedIndex];
          const available = option.dataset.available === 'true';
          root.querySelectorAll('[data-lm-price]').forEach((node) => { node.textContent = option.dataset.price; });
          root.querySelectorAll('[data-lm-add-button]').forEach((button) => { button.disabled = !available; });
          root.querySelectorAll('[data-lm-add-label]').forEach((node) => { node.textContent = available ? 'In den Warenkorb' : 'Ausverkauft'; });
        });
      }
    };

    document.querySelectorAll('[data-lm-product]').forEach(initProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const brandPattern = /\b(?:adidas|nike|puma|umbro|reebok|hummel|kappa|uhlsport|joma|erima|lotto|macron|new\s+balance|under\s+armour|le\s+coq\s+sportif|mizuno|asics|diadora|castore|jako|saller|patrick|erre[àa]|meyba|kelme)\b/gi;
    const typeDefinitions = [
      ['home', /\b(?:heim|home)(?:\s|-)?trikot\b/i],
      ['away', /\b(?:ausw(?:ä|ae)rts|away)(?:\s|-)?trikot\b/i],
      ['third', /\b(?:drittes|3\.?|third)(?:\s|-)?trikot\b/i],
      ['fourth', /\b(?:viertes|4\.?|fourth)(?:\s|-)?trikot\b/i],
      ['goalkeeper', /\btorwart(?:\s|-)?trikot\b/i],
      ['training', /\btrainings?(?:\s|-)?trikot\b/i],
      ['special', /\b(?:sonder|karnevals?)(?:\s|-)?trikot\b/i],
      ['shirt', /\btrikot\b/i]
    ];
    const clubAliases = new Map([
      ['hsv', 'hamburger sv'],
      ['dfb', 'deutschland'],
      ['1 fc koln', 'fc koln'],
      ['fc koln', 'fc koln']
    ]);
    const sizeRanks = new Map([
      ['XXXS', -1],
      ['XXS', 0],
      ['XS', 1],
      ['S', 2],
      ['M', 3],
      ['L', 4],
      ['XL', 5],
      ['XXL', 6],
      ['XXXL', 7],
      ['3XL', 7],
      ['4XL', 8],
      ['5XL', 9],
      ['6XL', 10]
    ]);

    const normalize = (value) => (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');

    const readSize = (title) => {
      const sizeTokenPattern = '(?:XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[3-6]XL)';
      const statedSizeMatch = title.match(new RegExp(`\\b(?:gr(?:ö|oe)ße|gr\\.?)\\s*(${sizeTokenPattern}(?:\\s*\\/\\s*${sizeTokenPattern})?|\\d+)`, 'i'));
      const parentheticalSizeMatch = title.match(new RegExp(`\\(\\s*(${sizeTokenPattern}(?:\\s*\\/\\s*${sizeTokenPattern})?)\\s*\\)`, 'i'));
      const rawSize = parentheticalSizeMatch ? parentheticalSizeMatch[1] : statedSizeMatch && statedSizeMatch[1];
      if (!rawSize) return { label: '', rank: null, match: statedSizeMatch || parentheticalSizeMatch };

      const sizes = rawSize
        .toUpperCase()
        .replace(/\s+/g, '')
        .split('/')
        .map((size) => size === 'XXXL' ? '3XL' : size);
      const ranks = sizes.map((size) => sizeRanks.get(size)).filter((rank) => rank !== undefined);

      return {
        label: sizes.join('/'),
        rank: ranks.length ? ranks.reduce((sum, rank) => sum + rank, 0) / ranks.length : null,
        match: statedSizeMatch || parentheticalSizeMatch
      };
    };

    const titleFeatures = (title) => {
      const seasonMatch = title.match(/\b((?:19|20)\d{2})(?:[-–/](?:\d{2}|(?:19|20)\d{2}))?\b/);
      const size = readSize(title);
      const sizeMatch = size.match;
      const typeDefinition = typeDefinitions.find((definition) => definition[1].test(title));
      const typeMatch = typeDefinition ? title.match(typeDefinition[1]) : null;
      const boundaries = [seasonMatch, sizeMatch, typeMatch]
        .filter(Boolean)
        .map((match) => match.index);
      const clubEnd = boundaries.length ? Math.min(...boundaries) : title.length;
      const club = title
        .slice(0, clubEnd)
        .replace(brandPattern, '')
        .replace(/^[-–—·\s]+|[-–—·\s]+$/g, '')
        .trim();
      const normalizedClub = normalize(club).replace(/^1\s+(fc|fsv)\s+/, '$1 ');

      return {
        club,
        clubKey: clubAliases.get(normalizedClub) || normalizedClub,
        season: seasonMatch ? Number(seasonMatch[1]) : null,
        decade: seasonMatch ? Math.floor(Number(seasonMatch[1]) / 10) * 10 : null,
        type: typeDefinition ? typeDefinition[0] : '',
        size: size.label,
        sizeRank: size.rank
      };
    };

    const sameClub = (candidate, current) => {
      if (!current.clubKey) return false;
      const candidateKey = titleFeatures(candidate.title || '').clubKey;
      if (!candidateKey) return false;
      if (candidateKey === current.clubKey) return true;
      if (candidateKey.length > 3 && current.clubKey.endsWith(` ${candidateKey}`)) return true;
      if (current.clubKey.length > 3 && candidateKey.endsWith(` ${current.clubKey}`)) return true;

      const ignoredTokens = new Set(['fc', 'fsv', 'sv', 'vfb', 'sc', 'tsv', 'vfl', 'ac', 'as']);
      const clubTokens = current.clubKey.split(' ').filter((token) => token.length > 2 && !ignoredTokens.has(token));
      const candidateTitle = normalize(candidate.title || '');
      return clubTokens.length > 0 && clubTokens.every((token) => candidateTitle.includes(token));
    };

    const getImage = (product) => {
      const image = product.featured_image || product.image || (product.featured_media && product.featured_media.preview_image);
      if (!image) return { url: '', alt: '' };
      if (typeof image === 'string') return { url: image, alt: product.title || '' };
      return {
        url: image.url || image.src || '',
        alt: image.alt || product.title || ''
      };
    };

    const imageUrl = (source, width) => {
      if (!source) return '';
      try {
        const url = new URL(source, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.toString();
      } catch (error) {
        return source;
      }
    };

    const productKey = (product) => String(product.id || product.handle || product.url || '');

    const isJersey = (product) => normalize(product.title || '').includes('trikot');

    const uniqueProducts = (products, currentId) => {
      const seen = new Set([String(currentId)]);
      return products.filter((product) => {
        const key = productKey(product);
        if (!key || seen.has(key) || product.available !== true) return false;
        seen.add(key);
        return true;
      });
    };

    const scoreProduct = (product, current) => {
      const candidate = titleFeatures(product.title || '');
      let score = 0;
      if (current.decade && candidate.decade === current.decade) score += 120;
      if (current.type && candidate.type === current.type) score += 45;
      if (current.season && candidate.season) {
        const distance = Math.abs(current.season - candidate.season);
        if (distance === 0) score += 60;
        else if (distance <= 2) score += 42;
        else if (distance <= 5) score += 24;
        else if (distance <= 9) score += 10;
      }
      if (current.sizeRank !== null && candidate.sizeRank !== null) {
        const sizeDistance = Math.abs(current.sizeRank - candidate.sizeRank);
        if (sizeDistance <= 0.25) score += 46;
        else if (sizeDistance <= 1) score += 32;
        else if (sizeDistance <= 2) score += 8;
        else score -= 60;
      }
      if (current.vendor && normalize(product.vendor) === current.vendor) score += 16;
      return score;
    };

    const sortByRelevance = (products, current) => products
      .map((product, index) => ({ product, index, score: scoreProduct(product, current) }))
      .sort((left, right) => right.score - left.score || left.index - right.index)
      .map((item) => item.product);

    const moneyAmount = (value) => {
      if (value === null || value === undefined || value === '') return '';
      const rawValue = typeof value === 'object' ? value.amount ?? value.value : value;
      const raw = String(rawValue).trim();
      const hasCurrency = /[€$£¥]|\b[A-Z]{3}\b/i.test(raw);
      const normalizedNumber = raw
        .replace(/[^0-9,.-]/g, '')
        .replace(',', '.');
      const number = Number(normalizedNumber);
      if (!Number.isFinite(number)) return null;
      if (typeof rawValue === 'number') return Number.isInteger(rawValue) ? rawValue / 100 : rawValue;
      if (hasCurrency || /[.,]\d{1,2}$/.test(raw)) return number;
      return number / 100;
    };

    const formatMoney = (value, currency) => {
      const amount = moneyAmount(value);
      if (amount === null || amount === '') return '';
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(amount);
    };

    const createCard = (product, category, root) => {
      const link = document.createElement('a');
      const media = document.createElement('span');
      const label = document.createElement('span');
      const title = document.createElement('span');
      const priceRow = document.createElement('span');
      const price = document.createElement('span');
      const comparePrice = document.createElement('s');
      const productImage = getImage(product);

      link.className = 'lm-related-products__card';
      link.href = product.url || `${window.Shopify.routes.root}products/${product.handle}`;
      media.className = 'lm-related-products__media';
      label.className = `lm-related-products__label${category === 'other' ? ' lm-related-products__label--other' : ''}`;
      label.textContent = category === 'other' ? root.dataset.otherLabel : root.dataset.sameClubLabel;
      title.className = 'lm-related-products__title';
      title.textContent = product.title || '';
      priceRow.className = 'lm-related-products__price-row';
      price.className = 'lm-related-products__price';
      price.textContent = formatMoney(product.price_min ?? product.price, root.dataset.currency);

      if (productImage.url) {
        const image = document.createElement('img');
        image.src = imageUrl(productImage.url, 540);
        image.srcset = `${imageUrl(productImage.url, 360)} 360w, ${imageUrl(productImage.url, 540)} 540w, ${imageUrl(productImage.url, 720)} 720w`;
        image.sizes = '(min-width: 990px) 20vw, 72vw';
        image.alt = productImage.alt;
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);
      }

      priceRow.appendChild(price);
      const compareValue = product.compare_at_price_min ?? product.compare_at_price;
      const currentAmount = moneyAmount(product.price_min ?? product.price);
      const compareAmount = moneyAmount(compareValue);
      if (compareAmount !== null && currentAmount !== null && compareAmount > currentAmount) {
        comparePrice.className = 'lm-related-products__compare-price';
        comparePrice.textContent = formatMoney(compareValue, root.dataset.currency);
        priceRow.appendChild(comparePrice);
      }

      link.append(media, label, title, priceRow);
      return link;
    };

    const initRelatedProducts = async (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const currentId = root.dataset.productId;
      const current = titleFeatures(root.dataset.productTitle || '');
      current.vendor = normalize(root.dataset.productVendor || '');
      const sameLimit = Number(root.dataset.sameClubLimit) || 3;
      const otherLimit = Number(root.dataset.otherLimit) || 2;
      const grid = root.querySelector('[data-lm-related-grid]');
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const searchParams = new URLSearchParams({
        q: current.club,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][unavailable_products]': 'hide'
      });
      const relatedParams = new URLSearchParams({
        product_id: currentId,
        limit: '10',
        intent: 'related'
      });

      try {
        const requests = [
          fetch(`${base}recommendations/products.json?${relatedParams}`, { credentials: 'same-origin' }).then((response) => response.ok ? response.json() : { products: [] })
        ];
        if (current.club) {
          requests.push(fetch(`${base}search/suggest.json?${searchParams}`, { credentials: 'same-origin' }).then((response) => response.ok ? response.json() : { resources: { results: { products: [] } } }));
        }

        const responses = await Promise.all(requests);
        const recommended = responses[0] && Array.isArray(responses[0].products) ? responses[0].products : [];
        const searched = responses[1] && responses[1].resources && responses[1].resources.results
          ? responses[1].resources.results.products || []
          : [];
        const pool = uniqueProducts([...searched, ...recommended], currentId);
        const sameClubProducts = sortByRelevance(pool.filter((product) => isJersey(product) && sameClub(product, current)), current);
        const otherProducts = sortByRelevance(
          uniqueProducts(recommended, currentId).filter((product) => isJersey(product) && !sameClub(product, current)),
          current
        ).slice(0, otherLimit);
        const extraSameSlots = Math.max(0, otherLimit - otherProducts.length);
        const selectedSame = sameClubProducts.slice(0, sameLimit + extraSameSlots);
        let selected = [
          ...selectedSame.map((product) => ({ product, category: 'same' })),
          ...otherProducts.map((product) => ({ product, category: 'other' }))
        ];

        if (!current.club || selected.length === 0) {
          selected = sortByRelevance(uniqueProducts(recommended, currentId).filter(isJersey), current)
            .slice(0, sameLimit + otherLimit)
            .map((product) => ({ product, category: 'other' }));
        }

        if (!selected.length || !grid) {
          root.hidden = true;
          return;
        }

        grid.replaceChildren(...selected.map((item) => createCard(item.product, item.category, root)));
        root.setAttribute('aria-busy', 'false');
      } catch (error) {
        root.hidden = true;
      }
    };

    const initAllRelatedProducts = (scope = document) => {
      scope.querySelectorAll('[data-lm-related-products]').forEach(initRelatedProducts);
    };

    initAllRelatedProducts();
    document.addEventListener('shopify:section:load', (event) => initAllRelatedProducts(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
